<template>
    <div>
        <div v-if="editable" class="row">
            <b-col sm="10">
                <p class="mb-1">
                    {{ data.civility }} {{ data.firstname }} {{ data.surname }}
                </p>
                <p class="mb-1">
                    {{ data.born }} le {{ data.formatted_date_of_birth }} à
                    {{ data.place_of_birth }}
                </p>
                <p class="mb-1">Nationalité {{ data.nationality }}</p>
                <p class="mb-2">{{ data.formatted_address }}</p>
            </b-col>
            <b-col sm="2 text-right">
                <b-button
                    variant="secondary"
                    size="sm"
                    title="Modifier la personne physique"
                    @click="editPhysicalPerson"
                >
                    <i class="fas fa-pencil fa-fw"></i>
                </b-button>
            </b-col>
        </div>
        <div v-else class="row">
            <b-col sm="12">
                <p class="mb-1">
                    {{ data.civility }} {{ data.firstname }} {{ data.surname }}
                </p>
                <p class="mb-1">
                    {{ data.born }} le {{ data.formatted_date_of_birth }} à
                    {{ data.place_of_birth }}
                </p>
                <p class="mb-1">Nationalité {{ data.nationality }}</p>
                <p class="mb-2">{{ data.formatted_address }}</p>
            </b-col>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PhysicalPersonData',

    props: {
        data: {},
        editable: null,
    },

    methods: {
        editPhysicalPerson() {
            this.$store.commit('legalVM/SET_PERSON_ID', this.data.id)
            this.$store.commit('legalVM/SET_PERSON_TYPE', 'physical')
            this.$store.commit('legalVM/SHOW_EDIT')
        },
    },
}
</script>

<style scoped></style>
